import Button, { UnderlineButton } from "src/components/Button/Button";
import useAvailableClaim from "src/hooks/useAvailableClaim";
import useAvailableWithdraw from "src/hooks/useAvailableWithdraw";
import { ReactComponent as WithdrawIcon } from "src/assets/icons/withdraw.svg";
import { ReactComponent as ClaimIcon } from "src/assets/icons/wallet.svg";
import { sendTransactions } from "@multiversx/sdk-dapp/services";
import { smartContract } from "src/utils/smartContract";
import { chainIdByEnvironment } from "@multiversx/sdk-dapp/constants/network";
import { Address } from "@multiversx/sdk-core/out";
import {
  displayedCurrencyCode,
  environment,
  gasLimit,
  tokenDecimal,
} from "src/config";
import { FormatAmount } from "@multiversx/sdk-dapp/UI";
import { handleUnexpectedException } from "src/helpers/functions";
import BigNumber from "bignumber.js";
import NextRewardsPeriod from "./NextRewardsPeriod";

export default function GlobalActions({ account, totalStakeAmounts }) {
  const { availableClaim } = useAvailableClaim(account.address);
  const { availableWithdraw } = useAvailableWithdraw(account.address);

  const handleClaim = async () => {
    try {
      const claimTransaction = smartContract.methodsExplicit
        .claim()
        .withSender(Address.fromBech32(account.address))
        .withGasLimit(gasLimit * 1.5)
        .withChainID(chainIdByEnvironment[environment])
        .buildTransaction()
        .toPlainObject();

      await sendTransactions({
        transactions: claimTransaction,
        transactionsDisplayInfo: {
          processingMessage: "Processing Claim transaction",
          errorMessage: "An error has occurred during Claim",
          successMessage: "Claim transaction successful",
        },
        redirectAfterSign: false,
      });
    } catch (error) {
      handleUnexpectedException(error);
    }
  };

  const handleWithdraw = async () => {
    try {
      const withdrawTransaction = smartContract.methodsExplicit
        .withdraw()
        .withSender(Address.fromBech32(account.address))
        .withGasLimit(gasLimit * 2)
        .withChainID(chainIdByEnvironment[environment])
        .buildTransaction()
        .toPlainObject();

      await sendTransactions({
        transactions: withdrawTransaction,
        transactionsDisplayInfo: {
          processingMessage: "Processing Withdraw transaction",
          errorMessage: "An error has occurred during Withdraw",
          successMessage: "Withdraw transaction successful",
        },
        redirectAfterSign: false,
      });
    } catch (error) {
      handleUnexpectedException(error);
    }
  };

  return (
    <div className="subPanel globalActions">
      <div className="labeledValue">
        <i>My Stake</i>
        <span>
          <FormatAmount
            value={Object.values(totalStakeAmounts)
              .reduce(
                (acc, amount) => acc.plus(new BigNumber(amount)),
                new BigNumber(0)
              )
              .toFixed()}
            decimals={tokenDecimal}
            showLabel={false}
          />

          <i> {displayedCurrencyCode}</i>
        </span>
      </div>
      <div className="labeledValue">
        <i>Total tokens to withdraw</i>
        <span>
          <FormatAmount
            value={availableWithdraw || 0}
            decimals={tokenDecimal}
            showLabel={false}
          />
          <i> {displayedCurrencyCode}</i>
        </span>
      </div>
      <div className="labeledValue">
        <i>Total rewards to claim</i>
        <span>
          <FormatAmount
            value={availableClaim || 0}
            decimals={tokenDecimal}
            showLabel={false}
          />
          <i> {displayedCurrencyCode}</i>
        </span>
      </div>

      <div className="actions">
        <UnderlineButton
          disabled={(availableWithdraw || 0) <= 0}
          onClick={handleWithdraw}
          icon={<WithdrawIcon />}
        >
          Withdraw
        </UnderlineButton>

        <Button
          disabled={(availableClaim || 0) <= 0}
          style={{ color: "white" }}
          onClick={handleClaim}
          icon={<ClaimIcon />}
        >
          Claim Rewards
        </Button>
      </div>

      <NextRewardsPeriod />
    </div>
  );
}
